import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router-dom';
import {
    Button,
    Breadcrumb, Icon,
    Grid, Form, Header, Checkbox,
    Divider, Popup, Image
} from 'semantic-ui-react';
import update from 'react-addons-update';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

import CustomDivider from '../../components/extras/CustomDivider';
import StorePaymentData from "../../data/StorePaymentData";
import connect from "react-redux/es/connect/connect";
import { showToast } from "../../actions/ToastAction";
import Loading from "../../components/extras/Loading";
import CheckPermission from "../../components/extras/CheckPermission";
let GLOBAL = require('../../data/globals');

const moneyMask = createNumberMask({
    prefix: '$',
});

const percentageMask = createNumberMask({
    prefix: '',
    suffix: '%',
    allowDecimal: true
});

class PaymentMethods extends Component {
    constructor() {
        super();
        this.state = {
            data: {
                has_payment_against_delivery: false,
                has_epayco: false,
                epayco_key: '',
                epayco_p_key: '',
                epayco_rate_price: 0,
                epayco_rate_percentage: 0
            },
            loading: true,
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleChangeToggle = this.handleChangeToggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.initialFetch();
    }

    handleChangeToggle = (e, { checked, name }) => {
        let data = update(this.state, {
            data: {
                [name]: { $set: checked }
            }
        });
        this.setState(data);
    }

    handleChange = (event) => {
        let value = isNaN(parseFloat(event.target.value.replace(/(?!-)[^0-9.]/g, ""))) ? '' : parseFloat(event.target.value.replace(/(?!-)[^0-9.]/g, ""));
        let data = update(this.state, {
            data: {
                [event.target.name]: { $set: value }
            }
        });
        this.setState(data);
    };

    handleTextChange = (event) => {
        let data = update(this.state, {
            data: {
                [event.target.name]: { $set: event.target.value }
            }
        });
        this.setState(data);
    };

    initialFetch() {
        StorePaymentData.get(res => {
            let data = {
                has_epayco: res.has_epayco,
                epayco_key: res.epayco_key,
                epayco_p_key: res.epayco_p_key,
                epayco_rate_price: res.epayco_rate_price,
                epayco_rate_percentage: res.epayco_rate_percentage
            };
            this.setState({ data, loading: false });
        });
    };

    async handleSubmit(event) {
        if (this.state.data.has_epayco && this.state.data.epayco_key.trim() === '') return;
        event.preventDefault();
        this.setState({ disabled_button: true });
        let data = this.state.data;
        data.epayco_rate_price = data.epayco_rate_price === '' ? 0 : data.epayco_rate_price;
        data.epayco_rate_percentage = data.epayco_rate_percentage === '' ? 0 : data.epayco_rate_percentage;
        
        StorePaymentData.update(data, (res) => {
            if (res.update) {
                this.props.showToast({ message: 'Información Actualizada!', type: 'success' });
            } else {
                this.props.showToast({ message: 'Tenemos un problema, inténtalo más tarde!', type: 'error' });
            }
            this.setState({ disabled_button: false });
        });
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Mi Sitio Web | Métodos de Pago - Quipuu</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section as={Link} to='/settings'>Configuraciones</Breadcrumb.Section>
                    <Breadcrumb.Divider />
                    <Breadcrumb.Section active>Métodos de Pago</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider />
                <Header as='h2'>
                    <Header.Content>
                        Configuración para Métodos de Pago
                    </Header.Content>
                </Header>
                <br />
                {!this.state.loading ?
                    <Grid>
                        <Grid.Row>
                            <Grid.Column mobile={16} tablet={8} computer={8}>
                                <Form onSubmit={this.handleSubmit}>
                                    <Form.Field>
                                        <Popup trigger={<label>¿Ofrece pagos por medio de ePayco <Icon fitted name='help' /></label>} flowing hoverable>
                                            <Grid centered divided columns={1}>
                                                <Grid.Column textAlign='center'>
                                                    <Header as='h4'>Ayuda</Header>
                                                    <p>
                                                        Esta información la puede encontrar en la siguiente dirección,
                                                        <br/>
                                                        en la sección de <strong>Llaves secretas</strong>
                                                        <br/>
                                                        <a href='https://dashboard.epayco.co/configuration' rel="noopener noreferrer" target='_blank'>https://dashboard.epayco.co/configuration</a>
                                                        <br/>
                                                        <Image src={`${ GLOBAL.STATIC_URL }img/help/epayco_secret_keys.png`} size='large' />
                                                    </p>
                                                </Grid.Column>
                                            </Grid>
                                        </Popup>
                                        <Checkbox
                                            name='has_epayco'
                                            toggle
                                            checked={this.state.data.has_epayco}
                                            label={`${this.state.data.has_epayco ? 'Si' : 'No'}`}
                                            onChange={this.handleChangeToggle}
                                        />
                                    </Form.Field>
                                    {this.state.data.has_epayco ?
                                        <Form.Input
                                            label='ePayco P_KEY'
                                            name='epayco_p_key'
                                            placeholder='ePayco P_KEY'
                                            error={this.state.data.has_epayco && this.state.data.epayco_p_key === ''}
                                            value={this.state.data.epayco_p_key}
                                            onChange={this.handleTextChange}
                                        /> : null}
                                    {this.state.data.has_epayco ?
                                        <Form.Input
                                            label='ePayco PUBLIC_KEY'
                                            name='epayco_key'
                                            placeholder='ePayco PUBLIC_KEY'
                                            error={this.state.data.has_epayco && this.state.data.epayco_key === ''}
                                            value={this.state.data.epayco_key}
                                            onChange={this.handleTextChange}
                                        /> : null}
                                    {this.state.data.has_epayco ?
                                        <Form.Input
                                            label='ePayco valor comisión'
                                            name='epayco_rate_price'
                                            children={
                                                <MaskedInput
                                                    name='epayco_rate_price'
                                                    value={this.state.data.epayco_rate_price}
                                                    mask={moneyMask}
                                                    placeholder='ePayco valor comisión'
                                                    onChange={this.handleChange}
                                                />
                                            }
                                        /> : null}
                                    {this.state.data.has_epayco ?
                                        <Form.Input
                                            label='ePayco comisión en porcentaje sobre la venta'
                                            children={
                                                <MaskedInput
                                                    name='epayco_rate_percentage'
                                                    value={this.state.data.epayco_rate_percentage}
                                                    mask={percentageMask}
                                                    placeholder='ePayco comisión en porcentaje sobre la venta'
                                                    onChange={this.handleChange}
                                                />
                                            }
                                        /> : null}
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Divider/>
                                            <Button primary fluid disabled={this.state.disabled_button} loading={this.state.disabled_button}
                                                type="submit" content="Actualizar Información" />
                                        </Grid.Column>
                                    </Grid.Row>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                    : <Grid.Row centered><Loading /></Grid.Row>}
                <CheckPermission access='website_edit' />
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(toast) {
            dispatch(showToast(toast))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(PaymentMethods)


// WEBPACK FOOTER //
// ./src/containers/settings/PaymentMethods.js